<h2 mat-dialog-title>Escolher Tipo de Associação</h2>

<mat-dialog-content fxLayout="column">
    <p style="margin-bottom: 20px; margin-top: 0; word-wrap: break-word; overflow-wrap: break-word;">
        Escolha como deseja processar a associação automática dos lançamentos:
    </p>

    <div fxLayout="column" fxLayoutGap="12px">
        <button mat-raised-button color="primary" (click)="escolherSemContaContabil()" class="opcao-button">
            <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%; text-align: left;">
                <div style="font-weight: 500; font-size: 14px; word-wrap: break-word; overflow-wrap: break-word; width: 100%;">
                    <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 18px; width: 18px; height: 18px;">
                        pending
                    </mat-icon>
                    Associar apenas lançamentos sem conta contábil
                </div>
                <div style="font-size: 12px; margin-top: 4px; opacity: 0.8; word-wrap: break-word; overflow-wrap: break-word; width: 100%; line-height: 1.4;">
                    Processa apenas os {{ linhasSemContaContabil }} lançamento(s) que ainda não possuem conta contábil associada
                </div>
            </div>
        </button>

        <button mat-raised-button color="accent" (click)="escolherTodas()" class="opcao-button">
            <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%; text-align: left;">
                <div style="font-weight: 500; font-size: 14px; word-wrap: break-word; overflow-wrap: break-word; width: 100%;">
                    <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 18px; width: 18px; height: 18px;">
                        refresh
                    </mat-icon>
                    Refazer para todos os lançamentos
                </div>
                <div style="font-size: 12px; margin-top: 4px; opacity: 0.8; word-wrap: break-word; overflow-wrap: break-word; width: 100%; line-height: 1.4;">
                    Reprocessa todos os {{ totalLinhas }} lançamento(s), sobrescrevendo associações existentes
                </div>
            </div>
        </button>
    </div>
</mat-dialog-content>


<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button (click)="cancelar()"
            mat-button
            type="button">
        CANCELAR
    </button>
</mat-dialog-actions>
